import snakecaseKeys from 'snakecase-keys';
import { CosmosBaseV1Beta1Coin, InjectiveTokenFactoryV1Beta1Tx, } from '@injectivelabs/core-proto-ts';
import { MsgBase } from '../../MsgBase.js';
/**
 * @category Messages
 */
export default class MsgBurn extends MsgBase {
    static fromJSON(params) {
        return new MsgBurn(params);
    }
    toProto() {
        const { params } = this;
        const coin = CosmosBaseV1Beta1Coin.Coin.create();
        coin.denom = params.amount.denom;
        coin.amount = params.amount.amount;
        const message = InjectiveTokenFactoryV1Beta1Tx.MsgBurn.create();
        message.sender = params.sender;
        message.amount = coin;
        if (params.burnFromAddress) {
            message.burnFromAddress = params.burnFromAddress;
        }
        return InjectiveTokenFactoryV1Beta1Tx.MsgBurn.fromPartial(message);
    }
    toData() {
        const proto = this.toProto();
        return {
            '@type': '/injective.tokenfactory.v1beta1.MsgBurn',
            ...proto,
        };
    }
    toAmino() {
        const proto = this.toProto();
        const message = {
            ...snakecaseKeys(proto),
            burnFromAddress: proto.burnFromAddress,
        };
        // eslint-disable-next-line @typescript-eslint/no-unused-vars
        const { burn_from_address, ...messageWithoutBurnFromAddress } = message;
        return {
            type: 'injective/tokenfactory/burn',
            value: messageWithoutBurnFromAddress,
        };
    }
    toWeb3Gw() {
        const amino = this.toAmino();
        const { value } = amino;
        return {
            '@type': '/injective.tokenfactory.v1beta1.MsgBurn',
            ...value,
        };
    }
    toEip712Types() {
        const map = new Map();
        map.set('TypeAmount', [
            {
                name: 'denom',
                type: 'string',
            },
            {
                name: 'amount',
                type: 'string',
            },
        ]);
        map.set('MsgValue', [
            {
                name: 'sender',
                type: 'string',
            },
            {
                name: 'amount',
                type: 'TypeAmount',
            },
            {
                name: 'burnFromAddress',
                type: 'string',
            },
        ]);
        return map;
    }
    toDirectSign() {
        const proto = this.toProto();
        return {
            type: '/injective.tokenfactory.v1beta1.MsgBurn',
            message: proto,
        };
    }
    toBinary() {
        return InjectiveTokenFactoryV1Beta1Tx.MsgBurn.encode(this.toProto()).finish();
    }
}
